/**
 * Reads a whole number typed into a text/number box. Returns null when the box is empty or not a valid number in range.
 *
 * Keep what the person types as TEXT and call this to interpret it. Turning every keystroke straight into a clamped number
 * makes an empty box snap back to the minimum, so a default of "1" could never be deleted (typing 4 gave 14).
 */
export function parseWholeNumber(text: string, min: number, max: number): number | null {
  const t = text.trim();
  if (!/^\d+$/.test(t)) return null;
  const n = Number(t);
  return n >= min && n <= max ? n : null;
}
